// ----------------------------------------------------------------------------
// Component: Product Showcase
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import "snippets/product-form/product-form";

// Style includes
import "./_product-showcase.scss";